import Spinner from "../../Loaders/Spinner/Spinner";

export default function FormButton({className,loading,text,showLoadingOnLeft,disabled, ...props}) {

    return (
        <button

            disabled={loading || disabled}
            className={`${className} disabled:bg-secondary-700 flex  justify-center flex-row items-center linear mt-2 w-full cursor-pointer rounded-xl bg-secondary-900 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-secondary-600 active:bg-secondary-900 dark:bg-secondary-900 dark:text-white dark:hover:bg-secondary-300 dark:active:bg-secondary-200`}
            {...props}>
            {
                !showLoadingOnLeft?loading ? <Spinner aria-label="Default status example"/> : props.children :<>
                    {loading && <Spinner aria-label="Default status example"/>}
                    <div className={"ml-2"}>{
                        props?.children
                    }</div>
                </>
            }
        </button>

    )
}


export  function DetButton({className,loading,text,disabled, ...props}) {

    return (
        <button

            disabled={loading || disabled}
            className={`${className} disabled:bg-secondary-700 flex  justify-center items-center linear mt-2  cursor-pointer rounded-xl bg-secondary-900  text-base font-medium text-white transition duration-200 hover:bg-secondary-600 active:bg-secondary-900 dark:bg-secondary-900 dark:text-white dark:hover:bg-secondary-300 dark:active:bg-secondary-200`}
            {...props}>
            {
                loading ? <Spinner aria-label="Default status example"/> : props?.children
            }
        </button>

    )
}
